import ApiService from '@api/api-service';


export const url = process.env.NODE_ENV === 'development' ? "/news" : "/";
export default new ApiService(url);